export enum ContactTagsActionEnum {
  tag_added = 'dashboard.contact_page.tag_added',
  tag_removed = 'dashboard.contact_page.tag_removed',
}
